import { UserDto } from "./ImpersonationDtos";

export const convert = (dto: UserDto, marketplace_id: number): string => {
  return dto.token_temporal;
}